import { FC } from "react"
import { useNavigate } from "react-router-dom"
import { useFetchRateTableConfigsQuery } from "../../../../redux/queries"
import { useBrandSearchParam } from "../../../hooks"
import { Brand } from "../../../../types"
import ConfigListShell from "../config-list-shell"
import RateTableConfigTable from "./table"

interface ConfigRateTableProps {
  brands: Brand[]
}

const ConfigRateTable: FC<ConfigRateTableProps> = ({ brands }) => {
  const navigate = useNavigate()
  const [selectedBrandId, setSelectedBrandId] = useBrandSearchParam()

  const { data, isFetching } = useFetchRateTableConfigsQuery(
    { brand_id: selectedBrandId ?? "" },
    { skip: !selectedBrandId }
  )

  return (
    <ConfigListShell
      brands={brands}
      selectedBrandId={selectedBrandId}
      onBrandChange={setSelectedBrandId}
    >
      {selectedBrandId ? (
        <RateTableConfigTable
          data={data ?? []}
          isFetching={isFetching}
          onSelect={id => navigate(`/config-admin/rate-table/${id}`)}
        />
      ) : null}
    </ConfigListShell>
  )
}

export default ConfigRateTable
